import store from '../store';
import axios from 'axios';
import router from "../router";

export default {
  name: 'groupsPlaceApi',

  checkMaintenance() {
    if (store.state.settings && store.state.settings.maintenanceMode) {
      window.location = "/maintenance"
      return true
    }
    return false
  },

  genHeader() {
    return {
      headers: {'Authorization': store.getters.apiKey, 'ui_version': process.env.BUILD_VERSION},
      withCredentials: true
    };
  },
  async logout(key) {  //we could already be logged out locally, so we need the key!
    if (!key) return
    if (key == "") return
    let ret;
    await axios.get(process.env.BACKEND_URL + "/api/v1/user/logout", {
      headers: {
        'Authorization': key,
        'ui_version': process.env.BUILD_VERSION
      }, withCredentials: true
    }).then(
      response => {
        ret = response;
      },
      error => {
        ret = error.response;
      }
    );
    return ret;
  },
  async groupBasics(vanityPath, mode) {
    if (this.checkMaintenance()) return
    let current = store.getters.currentGroup;
    if (!current || current.vanityPath != vanityPath) {
      await axios.get(process.env.BACKEND_URL + "/api/v1/group/info/" + vanityPath + "?mode=" + mode, this.genHeader()).then(
        response => {
          store.dispatch("setCurrentGroup", response.data);
        },
        error => {
          store.dispatch("setCurrentGroup", null);
        }
      );
    }
  },
  async waitGet(path) {
    let ret;
    await axios.get(process.env.BACKEND_URL + "/api/v1" + path, this.genHeader()).then(
      response => {
        ret = response;
      },
      error => {
        if (error.response.status == 401) {
          store.dispatch("logout");
          ret = error.response;
        } else ret = error.response;
      }
    );
    return ret;
  },
  get(path) {
    if (path != "/public/settings" && this.checkMaintenance()) return
    return axios.get(process.env.BACKEND_URL + "/api/v1" + path, this.genHeader());
  },
  getExternalBlob(path) {
    if (this.checkMaintenance()) return
    return axios.get(path);
  },
  getBlob(path) {
    if (this.checkMaintenance()) return
    let h = this.genHeader();
    h.responseType = "blob";
    return axios.get(process.env.BACKEND_URL + "/api/v1" + path, h);
  },
  postBlob(path, data) {
    if (this.checkMaintenance()) return
    let h = this.genHeader();
    h.responseType = "blob";
    return axios.post(process.env.BACKEND_URL + "/api/v1" + path, data, h);
  },
  reloadUser() {
    axios.get(process.env.BACKEND_URL + "/api/v1/user/details", this.genHeader()).then(
      (details) => {
        store.dispatch("setUserDetails", details.data);
      },
      (error) => {
        console.log("Error getting user details again.");
      });

  },
  post(path, data) {
    if (this.checkMaintenance()) return
    return axios.post(process.env.BACKEND_URL + "/api/v1" + path, data, this.genHeader());
  },
  put(path, data) {
    if (this.checkMaintenance()) return
    return axios.put(process.env.BACKEND_URL + "/api/v1" + path, data, this.genHeader());
  },
  postImage(path, file) {
    if (this.checkMaintenance()) return
    return this.postFile(path, file);
  },
  postFile(path, file) {
    if (this.checkMaintenance()) return
    let formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    let headers = this.genHeader;
    headers['Content-Type'] = 'multipart/form-data';
    return axios.post(process.env.BACKEND_URL + "/api/v1" + path, formData, this.genHeader());
  },
  delete(path) {
    if (this.checkMaintenance()) return
    return axios.delete(process.env.BACKEND_URL + "/api/v1" + path, this.genHeader());
  },
  async getUserDetails() {
    await axios.get(process.env.BACKEND_URL + "/api/v1/user/details", this.genHeader()).then(
      response => {
        store.dispatch("setUserDetails", response.data);
        /*if (!response.data.haveGeo && !response.data.geoDeclined && navigator.geolocation) {
         navigator.geolocation.getCurrentPosition(
         (position) => {
         this.post("/user/setGeo", {latitude: position.coords.latitude, longitude: position.coords.longitude}).then(
         response2 => {
         let u = store.getters.currentUser;
         u.haveGeo = true;
         },
         error2 => {
         console.error("Couldn't save GEO");
         });
         },
         (error) => {
         if (error.code == error.PERMISSION_DENIED) {
         this.post("/user/geoDenied", {}).then(
         response2 => {
         let u = store.getters.currentUser;
         u.geoDeclined = true;
         },
         error2 => {
         console.error("Couldn't save GEO");
         });
         }
         }
         );

         }*/
      },
      error => {
        if (error.response.status == 403 && document.location.href.indexOf("/login/oauth2") < 0) {  //Don't log out if cognito login is in process
          store.dispatch("loggedIn", false)
          this.logout();
          store.dispatch("logout")
        }
      }
    );
  },
  async completeLogin(auth, isNewUser) {
    console.log("Completing login.")
    localStorage.setItem("apiKey", auth)
    await store.dispatch("setApiKey", auth)
    await store.dispatch("setLoggedIn", true)
    await this.getUserDetails()
    let redirect = localStorage.getItem("redirectOnLogin")
    if (redirect) {
      localStorage.removeItem("redirectOnLogin")
      router.push(redirect)
    } else if (isNewUser) router.push("/new-user")
    else router.push("/")
  },
  trackGroupVisit(vanityPath) {
    if (this.checkMaintenance()) return
    this.post("/member/trackVisit/" + vanityPath, {}).then(
      () => {

      },
      error => {
        console.log("Got error tracking last visit.", error)
      }
    );
  },
  isStandalone() {
    if ('standalone' in window.navigator) {
      return window.navigator.standalone;
    } else {
      // Check for other indicators
      if (window.matchMedia('(display-mode: standalone)').matches) {
        return true;
      } else {
        return false;
      }
    }
  }

};
